import { CaptionedImage } from '@/components/controls';
import { useGroups, useNicheNominal, useUser } from '@/hooks';
import { listGroupLabels } from '@/utils';
import {
  Link as LinkIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import {
  Box,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';

export function IntelligenceItem({ item, onSettingsClick }) {
  const {
    query: { data: user },
  } = useUser(item.edited.username);
  const {
    query: { data: nominal },
  } = useNicheNominal(item.nominalId, { image: true });
  const {
    query: { data: groups },
  } = useGroups({ types: ['SECTOR', 'TEAM'] });

  return (
    <Card variant="outlined">
      <Stack>
        <CardContent sx={{ flexGrow: 1 }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: 'space-between' }}
          >
            <Typography variant="caption" color="textSecondary" gutterBottom>
              {user
                ? `${user?.displayName} - ${format(
                    new Date(item.edited.time),
                    'dd/MM/yyyy HH:mm',
                  )}`
                : '-'}
            </Typography>
            <Typography variant="caption" color="textSecondary" gutterBottom>
              {!!item && !!groups
                ? `${listGroupLabels('Group', item.groupCodes, groups)}`
                : ''}
            </Typography>
          </Stack>
          <Typography variant="h6" color="primary" sx={{ px: 1 }}>
            {item.intelligenceId}
          </Typography>
          <Typography sx={{ whiteSpace: 'pre-wrap', p: 1 }} gutterBottom>
            {item.message}
          </Typography>
          <Stack direction="row" spacing={1} sx={{ overflowX: 'auto' }}>
            {!!nominal && (
              <CaptionedImage
                imageSrc={nominal?.imageSrc}
                height={320}
                fallbackWidth={240}
                alt="Nominal"
                topCaption={item.nominalId}
                bottomCaption={[nominal?.forenames, nominal?.surname]
                  .filter(Boolean)
                  .join(' ')
                  .toLowerCase()}
                bottomCaptionProps={{ sx: { textTransform: 'capitalize' } }}
              />
            )}
            {!!item.imageSrc && (
              <img
                src={item?.imageSrc}
                alt="Related"
                height={320}
                style={{ borderRadius: 4 }}
              />
            )}
          </Stack>
        </CardContent>
        <CardActions>
          {!!item.linkHref && (
            <Tooltip title="Link">
              <IconButton size="small" href={item.linkHref} target="_blank">
                <LinkIcon />
              </IconButton>
            </Tooltip>
          )}
          <Box sx={{ flexGrow: 1 }} />
          <Tooltip title="Settings">
            <IconButton size="small" onClick={onSettingsClick}>
              <SettingsIcon />
            </IconButton>
          </Tooltip>
        </CardActions>
      </Stack>
    </Card>
  );
}
